module.exports = __webpack_public_path__ + "static/media/009-Foto_ID_1.6a2fbec8.mp3";